import { z } from 'zod';

/** GET /admin/stats — mirrors buildStatsResponse() in apps/api/src/routes/admin/stats.ts. */
export const adminStatsResponseSchema = z.object({
  users: z.object({
    total: z.number().int(),
    with_access: z.number().int(),
    waiting: z.number().int(),
    new_7d: z.number().int(),
    new_30d: z.number().int(),
  }),
  credits: z.object({
    granted: z.number().int(),
    spent: z.number().int(),
    live_balance: z.number().int(),
  }),
  llm: z.object({
    total_spent_usd: z.number().nullable(),
    balance_usd: z.number().nullable(),
  }),
  /** Builds rated in the last 30 days; like_share 0..1, null without ratings. */
  ratings: z.object({
    up: z.number().int(),
    down: z.number().int(),
    like_share: z.number().nullable(),
    last_comments: z.array(z.object({ job_id: z.number().int(), comment: z.string(), at: z.string() })),
  }),
  /**
   * Where people came from, all time (promo spec 6.3): `ig_post` = every Instagram post label,
   * other labels as they are; the five posts that brought the most people.
   */
  sources: z.object({
    groups: z.array(
      z.object({
        group: z.string(),
        came: z.number().int(),
        first_result: z.number().int(),
        paid: z.number().int(),
      }),
    ),
    top_posts: z.array(z.object({ label: z.string(), came: z.number().int() })),
  }),
});

export type AdminStatsResponse = z.infer<typeof adminStatsResponseSchema>;
